export default {"src":"/_next/static/media/bars.50829269.svg","height":15,"width":22,"blurWidth":0,"blurHeight":0};